var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRequestRemaining({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3602 37.71L10.5002 40.005C12.358 41.5851 14.4807 42.8242 16.7702 43.665L17.8052 40.86C15.8193 40.1377 13.9762 39.0715 12.3602 37.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 27L3.28516 27.615C3.71297 30.0383 4.5607 32.3683 5.79016 34.5L8.38516 33C7.34713 31.1348 6.63683 29.1054 6.28516 27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7302 7.14L16.6952 4.335C14.4322 5.18371 12.3355 6.42245 10.5002 7.995L12.3602 10.29C13.9536 8.93606 15.7708 7.87012 17.7302 7.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38516 15L5.79016 13.5C4.58408 15.6382 3.75211 17.9667 3.33016 20.385L6.33016 20.895C6.66806 18.8257 7.36343 16.8309 8.38516 15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 3V6C28.774 6 33.3524 7.89642 36.7281 11.2721C40.1037 14.6477 42.0002 19.2261 42.0002 24C42.0002 28.7739 40.1037 33.3523 36.7281 36.7279C33.3524 40.1036 28.774 42 24.0002 42V45C29.5697 45 34.9111 42.7875 38.8494 38.8492C42.7877 34.911 45.0002 29.5695 45.0002 24C45.0002 18.4305 42.7877 13.089 38.8494 9.15076C34.9111 5.21249 29.5697 3 24.0002 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRequestRemaining);
export default __webpack_public_path__ + "static/media/ic-request-remaining.d2b8629f92779ddbd130cbf600e09ee8.svg";
export { ForwardRef as ReactComponent };